export default __webpack_public_path__ + "static/media/districts.2628e12a.geojson";